import { Controller } from "@hotwired/stimulus"
import { get } from "@rails/request.js"

// Connects to data-controller="userdashboard"
export default class extends Controller {
	static targets = ["triggerElement"]

  connect() {
  }

  triggerElementTargetConnected(){
		get("/kartenfilters", { responseKind: "turbo-stream" })
	}
}
